<template>
  <tr>
    <td>{{order.orderId}}</td>
    <td>{{order.date | dateTime}}</td>
    <td>
      {{order.status.description}}
      <div class="info-table-contracted" :class="{'info-table-expanded': expanded}">
      <template v-if="order.paymentMethod.type == 'CC'">
      <img :src="urlPayment" width="31" height="28" class="credit-card">
        {{order.paymentMethod.creditCard.number}}
      </template>

      <template v-else-if="order.paymentMethod.type == 'DC'">
      <img :src="urlPayment" width="31" height="28" class="credit-card">
        {{order.paymentMethod.bankAccount.agencyNumber}} - {{order.paymentMethod.bankAccount.accountNumber}} - {{order.paymentMethod.bankAccount.accountDigit}}
      </template>

      <template v-else>
      <img :src="urlPayment" width="31" height="28" class="credit-card">
        {{order.paymentMethod.name}}
      </template>
      </div>
    </td>
    <td>
      {{order.type}}
      <div class="info-table-contracted" :class="{'info-table-expanded': expanded}">
        <p class="no-margin" v-for="d in order.products.product" :key="d.productId" >{{d.productName}}</p>
      </div>
    </td>
    <td class="text-right">
      <b>{{order.price | cents}}</b>
      <div class="info-table-contracted" :class="{'info-table-expanded': expanded}">
        <p class="no-margin" v-for="d in order.products.product" :key="d.productId">{{isDescont(d , d.valueTotal) | cents}}</p>
      </div>
    </td>
    <td class="text-right">
      <button type="button" data-toggle="tooltip" data-placement="top" class="btn btn-expand" @click="expanded=!expanded">
        <i class="icon-plus" :class="{'icon-minus': expanded}"></i>
      </button>
    </td>

  </tr>

</template>
<script>
  export default {
    props: ['order'],
    data(){
      return {
        expanded: false
      }
    },
    computed:{
      urlPayment(){
        let urlImage = this.order.paymentMethod.imagePath ? this.order.paymentMethod.imagePath.split('.')[0] : '';
        return `/static/payment-methods/${ urlImage }.svg`;
      },
    },
    methods:{
      isDescont(product,value){
        return product.productId == 11 ? (-1) * value : value;
      }

    }
  }
</script>
<style scoped lang="scss">
 .info-table-contracted {
    height: auto;
    overflow-y: auto;
    padding: 0;
    position: relative;
    top: 10px;
    margin-bottom: 6px;
    display: none;
  }
 .info-table-expanded {
   display: block;
   /*height: auto;*/
 }
  .btn-expand,
  .btn-expand:focus,
  .btn-expand:hover,
  .btn-expand:active {
    padding: 7px 10px;
    margin-top: 5px;
  }
  @media only screen and (max-width: 990px) {
    .credit-card {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// detail-order.vue?66afc309